import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import { APIProvider } from "@vis.gl/react-google-maps";
import { LicenseManager } from "ag-grid-enterprise";
import "ag-grid-enterprise/styles/ag-theme-balham.css";
import { MockAPIProvider, mockApiContextDefaultValues } from "helpers/contexts/MockAPIContext";
import { theme } from "helpers/theme";
import "primeflex/primeflex.css";

// must be imported in this order!
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "@fortawesome/fontawesome-pro/css/all.min.css";
import { ThemeProvider } from "styled-components";

import "@layout/sass/fundmanager.scss";
import Loading from "pages/Shared/Loading";
import { store } from "services/localStore/store";

import * as serviceWorker from "./serviceWorker";

LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_KEY);

// Static imports
// import AppWrapper from "./AppWrapper";
// import AppAddin from "./AppAddin";

// Dynamic imports
const AppWrapper = React.lazy(() => import("./AppWrapper.jsx"));

const container = document.getElementById("root");
const root = createRoot(container);
const renderApp = () => {
    root.render(
        <Suspense fallback={<Loading />}>
            <Provider store={store}>
                <MockAPIProvider value={mockApiContextDefaultValues}>
                    <ThemeProvider theme={theme}>
                        <Router>
                            <APIProvider
                                apiKey={process.env.REACT_APP_GOOGLE_AUTOCOMPLETE_KEY}
                                libraries={["places", "marker"]}
                                onLoad={() => console.log("Maps API loaded")}
                            >
                                <AppWrapper />
                            </APIProvider>
                        </Router>
                    </ThemeProvider>
                </MockAPIProvider>
            </Provider>
        </Suspense>
    );

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: http://bit.ly/CRA-PWA
    serviceWorker.unregister();
};

renderApp();
